import { Enums } from '@bode-canada/core';
import { RadioOptionProperty } from '@/ui-kit/components/form/controls/components/radio/enums';
import { SoldPropertyPageEvent } from '@/constants/AnalyticEvents';

export const SELLING_MOTIVATION_OPTIONS = [
  {
    [RadioOptionProperty.Label]: 'Actively planning to sell within 3 months',
    [RadioOptionProperty.Value]: Enums.SellingMotivationType.PLANNING_SELL_WITHIN_3,
  },
  {
    [RadioOptionProperty.Label]: 'Planning to sell beyond 3 months',
    [RadioOptionProperty.Value]: Enums.SellingMotivationType.ACTIVE_SELL_WITHIN_3,
  },
  {
    [RadioOptionProperty.Label]: 'No current plans to sell',
    [RadioOptionProperty.Value]: Enums.SellingMotivationType.NO_PLANS,
  },
];

export const SELLING_MOTIVATION_EVENTS_MAPPING = new Map<Enums.SellingMotivationType, string>([
  [Enums.SellingMotivationType.PLANNING_SELL_WITHIN_3, SoldPropertyPageEvent.SellInThreeMonthsClick],
  [Enums.SellingMotivationType.ACTIVE_SELL_WITHIN_3, SoldPropertyPageEvent.SellNowClick],
  [Enums.SellingMotivationType.NO_PLANS, SoldPropertyPageEvent.NoPlansToSellClick],
]);
